/**
 * @class Currency
 * @property {string} id Unique id
 * @property {string} name Name
 * @property {string} symbolBefore Symbol before value
 * @property {string} symbolAfter Symbol after value
 * @property {number} roundingPrecision Rounding precision
 * @property {string} defaultMutationId Id of default mutation for this currency
 * @property {string} code Currency code
 * @property {boolean} enabled Is currency enabled?
 * @this Currency
 */
export default class Currency {

	/**
	 * @return {Currency}
	 */
	static normalize(data) {
		return Object.assign(new Currency(), data);
	}

	/**
	 * @return {string}
	 */
	getCodeForUrl() {
		return this.code.toLowerCase();
	}

	/**
	 * @return {string}
	 */
	getSymbol() {
		if (this.symbolAfter) {
			return this.symbolAfter;
		}
		else if (this.symbolBefore) {
			return this.symbolBefore;
		}
		return '';
	}
}



// WEBPACK FOOTER //
// ./models/Currency.js